import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const [slugs, setSlugs] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ap-wish")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("ap-wish", JSON.stringify(slugs));
  }, [slugs]);

  const syncToServer = (next) => {
    const token = localStorage.getItem("ap-cust-token");
    if (token) api.accountWishlist(token, next).catch(() => {});
  };

  const toggle = (slug) =>
    setSlugs((prev) => {
      const next = prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug];
      syncToServer(next);
      return next;
    });

  const mergeFromServer = (serverSlugs) =>
    setSlugs((prev) => {
      const merged = [...new Set([...prev, ...serverSlugs])];
      syncToServer(merged);
      return merged;
    });

  const has = (slug) => slugs.includes(slug);

  return (
    <WishlistContext.Provider value={{ slugs, toggle, has, mergeFromServer, count: slugs.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
